// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../../../../graphql/api/index';

import { CmsImageSizesFragmentDoc } from '../../cmsImageSizes.fragment.generated';
import { ImageCommonFragmentDoc } from '../../imageCommon.fragment.generated';
import { ImageSizeFragmentDoc } from '../../imageSize.fragment.generated';
import { LinkFragmentDoc, LinkItemFragmentDoc, PageLinkFragmentDoc, PostLinkFragmentDoc, CustomLinkFragmentDoc, LinkQuestionnaireFragmentDoc, LinkItemOpenEnquiryFormFragmentDoc, LinkItemErRecommendationsFragmentDoc } from '../../index.generated';
export const SquareImageBoxFragmentDoc = `
    fragment squareImageBox on SquareImageBox {
  __typename
  image {
    ...cmsImageSizes
  }
  link {
    ...link
  }
}
    `;